/**
 * @file index.tsx
 *
 * @fileoverview Renders sharing button based on device and sharing option availability.
 */

import { SharingButtonProps } from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import { useIsMobile } from '~/vcl/hooks/useIsMobile';
import { useContext } from 'react';
import { PathContext } from '~/jobiqo/context/app';
import { PathContextInterface } from '~/jobiqo/models/app';
import SharingButtonNative from '~/jobiqo/components/SocialMedia/SharingButtons/components/Native';
import { useIsDesktop } from '~/vcl/hooks/useIsDesktop';
import SharingButtonDesktop from '~/jobiqo/components/SocialMedia/SharingButtons/components/Desktop';

export default function SocialMediaSharingButtons(props: SharingButtonProps) {
  const { host }: PathContextInterface = useContext(PathContext);
  const isMobile = useIsMobile();
  const isDesktop = useIsDesktop();
  const fullUrl = `${host}${props.url}`;

  // Render native sharing button if the device is mobile and the browser supports native sharing
  // otherwise render desktop sharing button.
  return (
    <>
      {typeof navigator !== 'undefined' &&
      'share' in navigator &&
      !isDesktop ? (
        <SharingButtonNative
          url={fullUrl}
          title={props.title}
          sharingEntity={props.sharingEntity}
          sharingEntityType={props.sharingEntityType}
        />
      ) : (
        <SharingButtonDesktop
          fullUrl={fullUrl}
          isMobile={isMobile}
          url={props.url}
          title={props.title}
          coloredIcons={props.coloredIcons}
          sharingEntity={props.sharingEntity}
          sharingEntityType={props.sharingEntityType}
        />
      )}
    </>
  );
}
export { SocialMediaSharingButtons };
